import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  REQSendPushNoti,
  RESSendPushNoti,
  FailSendPushNoti
} from "./actions";
import * as actions from "../../Authentication/redux/actions";
import { PUSH_SEND_URL } from "../config";
import { saveCampaign, makeCampaignId } from "../../PushNotiList/history";

/* Reads whatever the backend answered with ({ ERROR_CODE, MESSAGE } or plain text) */
function* readBody(request) {
  try {
    const body = yield request.text();
    if (!body) {
      return `HTTP ${request.status}`;
    }
    try {
      const parsed = JSON.parse(body);
      return parsed.MESSAGE || parsed.message || parsed.ERROR_CODE || body;
    } catch (error) {
      return body.slice(0, 300);
    }
  } catch (error) {
    return `HTTP ${request.status}`;
  }
}

/*
 * Sends one target at a time: the endpoint takes a single token or topic per call
 * (see PushNotificationService.assertTargetAllowed)
 */
function* SENDxPushNoti({ payload }) {
  const { requests, campaign } = payload;
  const results = [];

  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);

    for (let i = 0; i < requests.length; i += 1) {
      const { target, payload: body } = requests[i];
      try {
        const request = yield fetch(PUSH_SEND_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userid: tGUID,
            "x-id-token": "Bearer " + accessToken
          },
          body: JSON.stringify(body)
        });

        if (request.status === 401) {
          yield put(actions.autoSignOut());
          return;
        }

        if (request.ok) {
          const message = yield readBody(request);
          results.push({ target, ok: true, message });
        } else {
          const message = yield readBody(request);
          results.push({ target, ok: false, status: request.status, message });
        }
      } catch (error) {
        results.push({ target, ok: false, message: error.message || "ส่งไม่สำเร็จ" });
      }
    }

    const succeeded = results.filter(item => item.ok).length;
    const summary = {
      total: results.length,
      succeeded,
      failed: results.length - succeeded
    };

    let status = "SENT";
    if (succeeded === 0) {
      status = "FAILED";
    } else if (succeeded < results.length) {
      status = "PARTIAL";
    }

    yield call(saveCampaign, {
      ...campaign,
      id: campaign.id || makeCampaignId(),
      status,
      summary,
      results: results.map(item => ({
        target: item.target,
        ok: item.ok,
        message: item.message
      }))
    });

    yield put(RESSendPushNoti({ results, summary }));
  } catch (error) {
    yield put(FailSendPushNoti({ message: error.message }));
  }
}

export function* pushNotiComposeSaga() {
  yield all([takeLatest(REQSendPushNoti, SENDxPushNoti)]);
}
